<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第3章 真实世界的AI（3-1 概率和优势比）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig">现代AI方法之所以能在现实世界中实际发挥作用，主要是因为它处理不确定性因素的能力较强，而不象1960-1980年代早期的大多数老式方法那样，对不确定性问题显得无能为力。</div>
      <div class="text fontBig">在第 3 章中，我们将介绍以下三部分内容。</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">概率和优势比</span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">贝叶斯规则 </span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">朴素贝叶斯分类 </span>（0/2）</div>
      <div  id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第1节 概率与优势比</div></div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">在上一节中，我们讨论了在具有完备信息的地方（例如象棋这样的游戏）的搜索及其应用。但是，在现实世界中，很多问题却很少会如此清晰。</div>
      <div class="text fontBig">在现实中，除了存在完美信息问题外，还有许多未知可能性的问题，从丢失信息到故意欺骗，不一而足。</div>
      <div class="text fontBig">以无人驾驶汽车为例，您可以设定一个目标，从A到B，编写指令让汽车遵循所有法律法规，并以一种高效安全的方式行驶到达目的地。但如果交通状况比预期的要差，可能是因为前方发生了事故，或者天气突然变差？或者其他的随机事件，例如在街上弹跳的球或垃圾碎片直接飞入汽车摄像头？如图1所示。那将会产生什么后果呢？</div>
      <img style="width:400px;marginLeft:130px" src="../assets/07-01.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图1 面对意外情况的无人驾驶汽车</div>
      <div class="text fontBig">无人驾驶汽车需要使用各种传感器，包括类似于声纳的传感器和摄像头，来不断检测它的位置和周围环境。这些传感器从来都不是完美的，因为来自传感器的数据总是包含一些错误和不准确的信息（简称为“噪音”）。例如，一个传感器指示前方道路向左转，而另一个传感器有可能指示相反的方向。这就需要在不停车的情况下解决这类噪音问题，才能能保证汽车在道路上安全驾驶。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、概率</div>
      <div class="text fontBig">与1960-1980年代大多数早期的“老式”方法相对比，现代AI方法之所以能够处理现实世界中诸如自动驾驶之类的问题，就是因为它们具有处理不确定性因素的能力。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">1. 处理不确定性问题的历史</div>
      <div class="text fontBig">在AI的历史上，处理不确定和不精确信息的方式有很多种。</div>
      <div class="text fontBig">（1）模糊逻辑</div>
      <div class="text fontBig">您可能听说过模糊逻辑。模糊逻辑在一段时间以来一直是处理不确定和不准确信息的最佳方法之一，并且在许多客户应用中使用，例如洗衣机可以检测脏污程度，而且可以根据检测数据对应用程序进行相应调整。</div>
      <div class="text fontBig">（2）AI应用基于概率</div>
      <div class="text fontBig">概率是一种被证明在不确定性情况下进行推理的最佳方法，几乎所有当前的AI应用在某种程度上都基于概率。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/07-02.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图2 出现好牌的概率</div>
      <div class="text fontBig">2. 为什么概率很重要</div>
      <div class="text fontBig">我们可能最熟悉概率在游戏中的应用：在扑克中获得三张同花色牌的机会友多少（大约47分之一），在彩票中获胜的机会（很小）有多少，等等。然而，更重要的是，概率还可以用于量化和比较日常生活中的风险：如果你超速，撞车的机会有多大，抵押贷款利率在未来5年内上升5个百分点的机会有多大，或者AI将自动执行特定任务（比如在X光图像中检测骨折的骨头，或者在餐厅的等候台排队）的机会有多大？</div>
      <div class="text fontBig">（1）关于概率的关键一课</div>
      <div class="text fontBig">关于概率的最重要的一课不是概率演算。相反，它是一种将不确定性视为至少在原则上可以量化的东西的能力。这意味着我们可以像谈论数字一样谈论不确定性：数字可以被比较（“这件事比那件事更可能吗”），而且它们常常可以被测量。</div>
      <div class="text fontBig">当然，测量概率是很难的：我们通常需要对一个现象进行大量观察才能得出结论。然而，通过系统地收集数据，我们可以批判性地评估概率陈述，我们的数字有时会被发现是对是错。换言之，不确定性不会超出理性思考和讨论的范围，而概率则提供一种系统的方法可以做到这一点。</div>
      <div class="text fontBig">不确定性可以量化的事实至关重要，例如，在有关疫苗接种或其他公共政策的决策中。在进入市场之前，任何一种疫苗都要经过临床测试，这样它的益处和风险都被量化了。这些风险从来就不为人所知，但它们的规模通常是众所周知的，足以证明其收益是否大于风险。</div>
      <div class="text fontBig">（2）为什么量化不确定性很重要</div>
      <div class="text fontBig">如果我们认为不确定性是无法量化或测量的，那么不确定性方面可能成为理性讨论的障碍。例如，我们可能会争辩说，由于我们不清楚疫苗是否会产生有害的副作用，所以使用疫苗太危险了。然而，这可能会导致我们忽视一种危及生命的疾病，这种疾病将被疫苗根除。在大多数情况下，收益和风险被充分精确地知道，以清楚地看到一个比另一个更重要。</div>
      <div class="text fontBig">以上课程在许多日常场景和专业领域都很有用：例如，医生、法院法官或投资者必须处理不确定的信息，并根据这些信息做出合理的决定。由于这是一门人工智能课程，我们将讨论如何利用概率自动进行不确定推理。我们将使用的例子包括医疗诊断（虽然这通常不是我们希望完全自动化的任务），以及识别欺诈性电子邮件（“垃圾邮件”）。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习8：概率预测</b>（Ref/无法得出结论，错，错，无法得出结论）</div>
      <div class="text fontBig">对于本练习，请记住以上讨论的关键点：概率可以量化（用数字表示），它可以是对或错。但也要记住，通常不可能基于单个观察得出关于特定数字是对还是错的结论。</div>
      <div class="text fontBig">考虑以下四个概率预测和结果。根据有关预测正确性的结果，我们可以得出什么结论？我们是否可以得出结论，即预测给出的概率确实是正确的（选择“正确”），预测是错误的（选择“错误”），还是我们都不能得出结论（选择“无法得出结论”）？</div>
      <div class="text fontBig">1.天气预报明天下雨的概率90％，但结果却没雨。<input style="marginLeft:15px;" type="radio" v-model="choosesix" value="统计" :disabled="isDisabledOne"><label>统计</label><input style="marginLeft:15px;" type="radio" v-model="choosesix" value="机器人" :disabled="isDisabledOne"><label>机器人</label><input style="marginLeft:15px;" type="radio" v-model="choosesix" value="机器学习" :disabled="isDisabledOne"><label>机器学习</label></div>
      <div class="text fontBig">2.天气预报明天下雨的概率 0％，但当天却下雨。 <input style="marginLeft:15px;" type="radio" v-model="chooseseven" value="统计" :disabled="isDisabledOne"><label>统计</label><input style="marginLeft:15px;" type="radio" v-model="chooseseven" value="机器人" :disabled="isDisabledOne"><label>机器人</label><input style="marginLeft:15px;" type="radio" v-model="chooseseven" value="机器学习" :disabled="isDisabledOne"><label>机器学习</label></div>
      <div class="text fontBig">3.假设您长时间监视天气预报员。您只考虑天气预报提供80％降雨机会的日子</div>
      <div class="text fontBig">您会发现，从长远来看，平均每五天下雨三天。<input style="marginLeft:15px;" type="radio" v-model="chooseeight" value="统计" :disabled="isDisabledOne"><label>统计</label><input style="marginLeft:15px;" type="radio" v-model="chooseeight" value="机器人" :disabled="isDisabledOne"><label>机器人</label><input style="marginLeft:15px;" type="radio" v-model="chooseeight" value="机器学习" :disabled="isDisabledOne"><label>机器学习</label></div>
      <div class="text fontBig">5.在2016年美国总统大选中，著名政治预测博客“58”给克林顿赢得71.4％获</div>
      <div class="text fontBig">胜机会（特朗普28.6％）。但特朗普最终当选。 <input style="marginLeft:15px;" type="radio" v-model="choosenine" value="统计" :disabled="isDisabledOne"><label>统计</label><input style="marginLeft:15px;" type="radio" v-model="choosenine" value="机器人" :disabled="isDisabledOne"><label>机器人</label><input style="marginLeft:15px;" type="radio" v-model="choosenine" value="机器学习" :disabled="isDisabledOne"><label>机器学习</label></div>
      <button class="sentBtn" @click="sentBtnOne">提交</button>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">二、优势比</div>
      <div class="text fontBig">优势比(odds ratio；OR)是另外一种描述概率的方式。优势比将会告诉我们某种推测的概率比其反向推测的概率大多少。例如下雨的概率为0.25，不下雨的概率为0.75，我们就可以说下雨的优势比为1:3，或者不下雨的优势比为3:1。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">1. 为何使用优势比而非百分比</div>
      <div class="text fontBig">优势比是3:1（三比一），这意味着我们期望每三个案例的结果（例如赢得一个赌注）有一个相反结果的案例，而非赢得该赌注。表示相同的另一种方式是说获胜的机会是3/4（四分之三），这被称为自然频率（概率），因为它们仅涉及整数，例如，四个人，其中三个有黑色的眼睛，或四天中有三天下雨。如图3所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/07-03.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图3 四个人中有三人黑眼睛</div>
      <div class="text fontBig">四分之三当然等于75％（数学家更喜欢使用0.75之类的小数代替百分比）。已经发现，在处理分数和百分比时，与自然频率或优势比相比，人们会感到困惑并且更容易犯错误。这就是为什么我们在方便时使用自然频率和优势比的原因。</div>
      <div class="text fontBig">2. 优势比不全等于概率</div>
      <div class="text fontBig">需要注意的是，虽然优势比也是一种描述概率的方式，但并非全等于概率。优势比表示为两个数字之比，其值可以大于1，而概率则不可能大于1或100%。即使优势比是1:5（1赢5输），也可以表示为十进制数0.2，但它却不同于20％的概率（或用数学家的记数法表示的概率0.2）。1:5的优势比意味着您必须玩六次游戏才能平均获得一胜。</div>
      <div class="text fontBig">对于大于1的优势比，例如5:1，很容易记住我们不是在处理概率，因为没有概率可以大于1，而对于小于1的优势比例如1:5，不确定的危险就隐藏其中。因此，请确保您始终知道我们何时在谈论优势比，何时在谈论概率。</div>
      <div class="text fontBig">以下练习将帮助您练习如何处理优势比与概率之间的对应关系。如果您在此阶段犯了一些错误，请不要担心：主要目标是学习下一部分将需要的技能。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习9：优势比</b>（Ref/ 1/47，156/365，72/365，2.1%，42.7%，19.7%）</div>
      <div class="text fontBig">正如我们上面已经提到的，优势比3:1（例如，每个无雨天有3个雨天）对应于概率0.75（或百分比为75％）。</div>
      <div class="text fontBig">通常，如果赞成某事件的优势比是x:y，则该事件的概率由x /（x + y）给出。如果愿意，请尝试以3:1的优势比进行尝试。您应该得到答案0.75。</div>
      <div class="text fontBig">正如我们还指出的那样，优势比6:2的概率与优势比3:1的概率完全相同，因为当我们让x = 6和y = 2并将它们写在公式x /（x + y）中时，得到6 /（6 + 2），结果为6/8 = 3/4 = 0.75。</div>
      <div class="text fontBig">你的任务:</div>
      <div class="text fontBig">对于前三个项1-3，从优势比转换为以自然频率表示的概率；例如从1:1到1/2。给出答案的分数，例如2/3。</div>
      <div class="text fontBig">对于最后三个项目4–6，将优势比转换为以百分比表示的概率（例如4.2％）。用一个小数百分比（例如12.2％）给出答案。</div>
      <div class="text fontBig">提示：计算将使用一个简单的计算器来计算，并且公式可以在上面找到。</div>
      <div class="text fontBig" style="textAlign:center;">1.获得三张同花色牌的优势比约1:46。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <div class="text fontBig" style="textAlign:center;">2.广州下雨的优势比是156:209。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <div class="text fontBig" style="textAlign:center;">3.北京下雨的优势比是72:293。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <div class="text fontBig" style="textAlign:center;">4.获得三张同花色牌的优势比约1:46。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <div class="text fontBig" style="textAlign:center;">5.广州下雨的优势比是156:209。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <div class="text fontBig" style="textAlign:center;">6.北京下雨的优势比是72:293。 回答：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtn">提交</button>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      choosesix:'',
      chooseseven:'',
      chooseeight:'',
      choosenine:'',
      isDisabledOne:false,
      contenteditable:false,
    }
  },
  methods:{
    sentBtnOne(){
      this.isDisabledOne = true;
    },
    sentBtn(){
      this.contenteditable = true;
    },
    jumpOne(){
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    jumpTow(){
      this.$router.push('/chapterEight');
    },
    jumpThree(){
      this.$router.push('/chapterNine');
    },
    goBlank(){
      this.$router.push('/chapterSix');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/chapterEight');
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.anwserInput{
  border: none;
  outline: none;
  border-bottom: 1px solid;
  font-size:16px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterSeven.vue